import NestedFormController from "./nested_form_controller";

// Delivery-zone band editor: nested-form rows whose readonly "from" cells are
// re-derived in cascade — bands stay contiguous by construction while typing.
// Only the last visible row is removable (and never below min rows), so zones
// can only shrink from the tail and the chaining stays intact. The optional
// product-map below the rows mirrors the bands as concentric circles.
export default class extends NestedFormController {
  static targets = [
    ...NestedFormController.targets,
    "minValue",
    "maxField",
    "feeField",
    "mapAddress",
    "mapCanvas",
  ];

  add(event) {
    super.add(event);
    this.rechain();
    this.maxFieldOf(this.visibleWrappers.at(-1)).focus();
  }

  remove(event) {
    super.remove(event);
    this.rechain();
  }

  disableButtons() {
    const wrappers = this.visibleWrappers;
    const lastWrapper = wrappers[wrappers.length - 1];

    this.trashButtonTargets.forEach((button) => {
      const wrapper = button.closest(this.wrapperSelectorValue);
      button.disabled = wrappers.length <= this.min || wrapper !== lastWrapper;
    });

    this.hideAddButton();
  }

  initialDisableButtons() {
    this.disableButtons();
  }

  rechain() {
    let runningMin = "0";

    this.visibleWrappers.forEach((wrapper) => {
      wrapper.querySelector(
        "[data-delivery-zones-form-target='minValue']",
      ).textContent = runningMin;

      const max = this.maxFieldOf(wrapper).value;
      if (max !== "") runningMin = max;
    });

    this.toggleAddButton();
    this.refreshMap();
  }

  // A new band can only follow a complete one: the pending row must reach past
  // the previous band and carry a fee before the add button reopens.
  toggleAddButton() {
    this.addButtonTarget.disabled = !this.lastZoneComplete;
  }

  get lastZoneComplete() {
    const wrappers = this.visibleWrappers;
    const last = wrappers.at(-1);
    if (!last) return false;

    const previousMax = wrappers.length > 1 ? parseFloat(this.maxFieldOf(wrappers.at(-2)).value) || 0 : 0;
    const max = parseFloat(this.maxFieldOf(last).value);
    const fee = last.querySelector("[data-delivery-zones-form-target='feeField']").value;

    return max > previousMax && fee !== "";
  }

  refreshMap() {
    if (!this.hasMapAddressTarget || !this.hasMapCanvasTarget) return;

    this.mapAddressTarget.dataset.circleRadii = JSON.stringify(this.zoneRadii);
    delete this.mapCanvasTarget.dataset.productMapTarget;

    requestAnimationFrame(() => {
      this.mapCanvasTarget.dataset.productMapTarget = "map";
    });
  }

  maxFieldOf(wrapper) {
    return wrapper.querySelector("[data-delivery-zones-form-target='maxField']");
  }

  get zoneRadii() {
    return this.visibleWrappers
      .map((wrapper) => parseFloat(this.maxFieldOf(wrapper).value))
      .filter((radius) => radius > 0);
  }

  // Removed persisted rows are display:none'd by the library; server-rendered
  // _destroy rows carry d-none. Both stay in the DOM and must be skipped.
  get visibleWrappers() {
    return Array.from(
      this.element.querySelectorAll(this.wrapperSelectorValue),
    ).filter(
      (wrapper) =>
        wrapper.style.display !== "none" &&
        !wrapper.classList.contains("d-none"),
    );
  }
}
